import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'

import type { FilterState, FilterUIState } from 'features/filters/store'
import {
  initialFilterState,
  useFilterStore,
  useFilterUIStore,
} from 'features/filters/store'
import { initialFilterUIState } from 'features/filters/store'
import { Root } from 'features/project/Root'
import { useProjectStore } from 'features/project/store'
import { HOME } from 'features/projects/paths'
import { getScreenIdFromPath } from 'routes/builders'
import mixpanel from 'trackers/mixpanel'
import { ProjectState } from 'types/project'

type RouteParams = { id: string }
export const Project = (): JSX.Element | null => {
  const { id } = useParams<RouteParams>()
  const navigate = useNavigate()
  const location = useLocation()

  const projectId = useProjectStore((state: ProjectState) => state.projectId)
  const setProjectId = useProjectStore(
    (state: ProjectState) => state.setProjectId,
  )
  const setFilters = useFilterStore((state: FilterState) => state.setFilters)
  const setFilterList = useFilterUIStore(
    (state: FilterUIState) => state.setFilterList,
  )
  const setDefaultFilterList = useFilterUIStore(
    (state: FilterUIState) => state.setDefaultFilterList,
  )
  const setHasLoadedFilters = useFilterStore(
    (state: FilterState) => state.setHasLoadedFilters,
  )

  useEffect(() => {
    if (id) {
      // Detect hub switch and reset filters BEFORE setting new projectId
      const isProjectChange = projectId && projectId !== id
      const hasUrlFilters = !!getScreenIdFromPath(location.pathname)

      if (isProjectChange && !hasUrlFilters) {
        // Fallback: Reset filter state if not already reset by HubSelector
        // This handles edge cases like browser back/forward navigation
        setHasLoadedFilters(false)
        setFilters(initialFilterState.filters)
        setFilterList(initialFilterUIState.filterList)
        setDefaultFilterList(initialFilterUIState.defaultFilterList)
      }

      mixpanel.register({ proj_uuid: id })
      setProjectId(id)
    }
  }, [
    id,
    projectId,
    setFilters,
    setFilterList,
    setDefaultFilterList,
    setHasLoadedFilters,
    setProjectId,
    location.pathname,
  ])

  // TODO this will come to represent Group Id
  useEffect(() => {
    if (!id) navigate(HOME)
  }, [id, navigate])

  if (!id) return null

  return <Root projectId={id} />
}
